import gsap from "gsap";
import DefaultBlock from "/scripts/default/block";

export default class UIToggle extends DefaultBlock {
	init() {
		this.DOM = {
			dashboard: document.getElementById("ui-dashboard"),
			toggleBtn: this.block.querySelector("#ui-toggle-btn"),
			toggleBtnText: this.block.querySelector("#ui-toggle-btn-text"),
			sun: this.block.querySelector("#ui-toggle-btn-sun"),
			moon: this.block.querySelector("#ui-toggle-btn-moon"),
			toggleFlairDark: this.block.querySelector("#toggle_dark"),
			toggleFlairLight: this.block.querySelector("#toggle_light"),
		};
		this.state = {
			theme: "dark",
		};

		this.setLightModeEvent = new Event("setLightMode", {
			bubbles: true,
			cancelable: true,
		});
		this.setNightModeEvent = new Event("setNightMode", {
			bubbles: true,
			cancelable: true,
		});

		this.buildOn();
	}

	buildOn() {
		gsap.set(this.block, { autoAlpha: 1 });
	}

	toggleTheme() {
		const { theme } = this.state;
		const tl = gsap.timeline({
			delay: 0.1,
		});

		tl.to(this.DOM.toggleFlairDark, {
			x: theme === "dark" ? -124 : 0,
			rotate: theme === "dark" ? -180 : 0,
			transformOrigin: "50% 50%",
			ease: "back.inOut(1.4)",
			duration: 0.4,
		})
			.to(
				this.DOM.toggleFlairLight,
				{
					x: theme === "dark" ? 124 : 0,
					rotate: theme === "dark" ? 180 : 0,
					transformOrigin: "50% 50%",
					ease: "back.inOut(1.4)",
					duration: 0.4,
				},
				0
			)
			.to(
				this.DOM.moon,
				{
					scale: theme === "dark" ? 0 : 1,
					rotate: theme === "dark" ? -40 : 0,
					duration: 0.2,
					ease: "back.out(2)",
				},
				0
			)
			.to(
				this.DOM.sun,
				{
					scale: theme === "dark" ? 1 : 0,
					duration: 0.2,
					ease: "power3.inOut",
				},
				0
			);

		this.DOM.toggleBtnText.innerText =
			theme === "dark" ? "Light mode" : "Night mode";

		// Set the new theme
		document.dispatchEvent(
			theme === "dark" ? this.setLightModeEvent : this.setNightModeEvent
		);
		this.state.theme = this.state.theme === "dark" ? "light" : "dark";
		this.DOM.dashboard.dataset.theme = this.state.theme;
	}

	initEvents() {
		this.DOM.toggleBtn.addEventListener("click", () => {
			this.toggleTheme();
		});
	}
}
